import React from "react";
import { FcFlashOn } from "react-icons/fc";
import { FormattedMessage, injectIntl } from "react-intl";
import cx from 'classnames';
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { connect } from "react-redux";
import { Crown, Star } from 'lucide-react';

import MarketingPrice from "../../MarketingPrice/MarketingPrice";
import ListingPhotos from "../../SearchListing/ListingPhotos";
import WishListIcon from "../../WishListIcon/WishListIcon";
import VideoPreview from "../../VideoPreview";

import messages from "../../../locale/messages";
import { formatURL } from "../../../helpers/formatURL";

import startIcon from '/public/SiteIcons/star.svg';
import arrowIcon from '/public/SiteIcons/rentNowArrow.svg';
import steeringIcon from '/public/SiteIcons/steeringIcon.svg';

import s from '../../Home/HomeSlider/HomeSlider.css';
import cs from '../../../components/commonStyle.css';

class CommonListingItems extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isHovering: false,
            currentSlide: 0
        };
    }

    handleMouseEnter = () => {
        this.setState({ isHovering: true });
    }

    handleMouseLeave = () => {
        this.setState({ isHovering: false });
    }

    handleSlideChange = (slideIndex) => {
        this.setState({ currentSlide: slideIndex });
    }

    render() {
        const { key, id, wishListStatus, basePrice, hourlyPrice, currency, bookingType, bookingMode, title, carType, transmissionLabel, starRatingValue, isFeatured, featuredTier } = this.props;
        const { account, userId, reviewsStarRating, coverPhoto, listPhotos, isListingSwiper, isEditWishList, transmission, youtubeVideoId } = this.props;
        const { formatMessage } = this.props.intl;
        let currentUser = account?.userId, isWhisListIcon = false;

        if (userId == currentUser) {
            isWhisListIcon = true;
        }

        const isPremium = featuredTier === 'premium';

        return (
            <div>
                <div>
                    {
                        !isWhisListIcon && <WishListIcon listId={id} key={key} isChecked={wishListStatus} isEditWishList={isEditWishList} />
                    }
                    {isFeatured && (
                        <div className={isPremium ? s.featuredBadgePremium : s.featuredBadge}>
                            <span>{isPremium ? <><Crown size={14} /> Premium</> : <><Star size={14} /> Destacado</>}</span>
                        </div>
                    )}
                    <div className={s.boxShadowmain}>
                        <div
                            style={{ position: 'relative' }}
                            onMouseEnter={this.handleMouseEnter}
                            onMouseLeave={this.handleMouseLeave}
                        >
                            <ListingPhotos
                                id={id}
                                listPhotos={listPhotos}
                                coverPhoto={coverPhoto}
                                formatURL={formatURL}
                                title={title}
                                personalizeURL=""
                                onSlideChange={this.handleSlideChange}
                            />
                            {youtubeVideoId && this.state.currentSlide === 0 && (
                                <VideoPreview
                                    youtubeUrl={youtubeVideoId}
                                    thumbnailUrl={listPhotos && listPhotos.length > 0 ? `/images/upload/x_medium_${(listPhotos.find(p => p.id === coverPhoto) || listPhotos[0])?.name?.replace(/\.(jpe?g|png)$/i, '.webp')}` : ''}
                                    alt={title}
                                    isOverlay={true}
                                    isHovering={this.state.isHovering}
                                />
                            )}
                        </div>
                        <a
                            href={"/boats/" + formatURL(title) + '-' + id}
                            className={cs.textDecorationNone}
                            onClick={() => {
                                // Track if user came from Featured listing for bid deduction
                                if (isFeatured && typeof window !== 'undefined') {
                                    sessionStorage.setItem('featuredClickListId', id);
                                    sessionStorage.setItem('featuredClickTimestamp', Date.now());
                                }
                            }}
                        >
                            <div className={s.boxShadow}>
                                <div className={s.PerDayWrap}></div>
                                <div className={s.sliderbackground}>
                                    <div className={cx(s.HRDetails, 'HRDetailsRTL')}>
                                        <div className={cx(s.trip, s.hiddentextSlider, 'hiddentextSliderRTL')}>
                                            <img src={steeringIcon} className={cx(s.carType, 'carTypeIconRTL')} alt="Tipo de bote" />
                                            <span className='carTypeRTL'>{carType}</span>
                                            <span className={s.dotCss}></span>
                                            <span className={s.textFlow}>{transmissionLabel}</span>
                                        </div>
                                    </div>
                                    <div className={cx(s.flex)}>
                                        {/* per/hour - show if bookingMode is 'hourly' or 'both' or undefined */}
                                        {(bookingMode === 'hourly' || bookingMode === 'both' || !bookingMode) && hourlyPrice > 0 && (
                                            <div className={cx(s.PerDay)}>
                                                {bookingType === "instant" && <span><FcFlashOn className={s.instantIcon} /></span>}
                                                <MarketingPrice amount={hourlyPrice} from={currency} />
                                                <span className={cx(s.perNightCss, 'PerDayRTL')}>{' '}{formatMessage(messages.perHour)}</span>
                                            </div>
                                        )}
                                        {/* per/day - show if bookingMode is 'daily' or 'both' or undefined */}
                                        {(bookingMode === 'daily' || bookingMode === 'both' || !bookingMode) && (
                                            <div className={cx(s.PerDay)}>
                                                {bookingType === "instant" && <span><FcFlashOn className={s.instantIcon} /></span>}
                                                <MarketingPrice amount={basePrice} from={currency} />
                                                <span className={cx(s.perNightCss, 'PerDayRTL')}>{' '}{formatMessage(messages.perNight)}</span>
                                            </div>
                                        )}
                                    </div>
                                    <h3 className={s.titleCss}>{title}</h3>
                                    <div className={s.HRRight}>
                                        {starRatingValue > 0 && <div className={cx(s.reviewCss, 'reviewCssSliderRTL')}>
                                            <img src={startIcon} className={cx(s.reviewCssImg, 'reviewCssImgRTL')} alt="Calificación" /><span>{starRatingValue}</span>
                                        </div>}
                                        <span className={cx(s.btn, cs.textDecorationNone)}>
                                            <span className={cs.vtrMiddle}><FormattedMessage {...messages.rentNowText} /></span>
                                            <img src={arrowIcon} className={cx(s.arrowIconCss, 'sliderArrowRTL')} alt="" />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        )
    }

}

const mapState = (state) => ({
    account: state?.account?.data
});

const mapDispatch = {};

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(CommonListingItems)));